import { Module } from "./index"
import * as paths from "constants/paths"
import * as modules from "constants/features"
import Transactional from "components/Transactional"
import TransactionalBenchmark from "components/Transactional/Benchmark"
import CrossSelling from "components/Transactional/CrossSelling"
import PerformanceGrowthProfiling from "components/Transactional/GrowthProfiling"
import SelloutReportSubmodule from "components/Transactional/SelloutReport"
import { addWeeks } from "date-fns"

const modulesDates: Record<string, Date> = {
	[paths.TRANSACTIONAL_CROSS_SELLING]: new Date("2024-09-04"),
}

const TransactionalModule: Module = {
	module: modules.TRANSACTIONAL_MODULE,
	component: Transactional,
	path: paths.TRANSACTIONAL,
	submodules: [
		{
			module: modules.BENCHMARK_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK,
		},
		{
			module: modules.BENCHMARK_BY_CHANNEL_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK_BY_CHANNELS,
		},
		{
			module: modules.BENCHMARK_TOTAL_SALES_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK_BY_TOTAL_SALES,
		},
		{
			module: modules.BENCHMARK_BY_BRAND_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK_BY_BRANDS,
		},
		{
			module: modules.BENCHMARK_BY_FORMAT_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK_BY_FORMATS,
		},
		{
			module: modules.BENCHMARK_BY_LOCATION_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_BENCHMARK_BY_LOCATION,
		},
		{
			module: modules.PERFORMANCE_GROWTH_PROFILING,
			component: PerformanceGrowthProfiling,
			path: paths.PERFORMANCE_GROWTH_PROFILING,
		},
		{
			module: modules.CROSS_SELLING_SUBMODULE,
			component: CrossSelling,
			path: paths.TRANSACTIONAL_CROSS_SELLING,
			isNewModule: true,
			startDate: modulesDates[paths.TRANSACTIONAL_CROSS_SELLING],
			endDate: addWeeks(modulesDates[paths.TRANSACTIONAL_CROSS_SELLING], 4),
		},
		{
			module: modules.SELLOUT_REPORT_SUBMODULE,
			component: SelloutReportSubmodule,
			path: paths.SELLOUT_REPORT_SUBMODULE,
		},
		{
			module: modules.VALUE_SHARED_MODEL_SUBMODULE,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL,
		},
		{
			module: modules.VALUE_SHARED_MODEL_BY_LEVEL,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LEVEL,
		},
		{
			module: modules.VALUE_SHARED_MODEL_BY_LOCATION,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LOCATION,
		},
		{
			module: modules.VALUE_SHARED_MODEL_BY_CHANNEL,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_CHANNEL,
		},
		{
			module: modules.VALUE_SHARED_MODEL_BY_FORMAT,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_FORMAT,
		},
		{
			module: modules.VALUE_SHARED_MODEL_BY_BRAND,
			component: TransactionalBenchmark,
			path: paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_BRAND,
		},
	],
}

export default TransactionalModule
